import api, { API_GET_IS_ADMIN } from ".";

// internal
// admins = protico team

export const getIsAdmin = async () => {
  try {
    const response = await api.get(API_GET_IS_ADMIN);
    return response.data as boolean;
  } catch (err) {
    return false;
  }
};
